import { render, staticRenderFns } from "./star-map.vue?vue&type=template&id=6ea7b86c"
import script from "./star-map.vue?vue&type=script&lang=js"
export * from "./star-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports